export default __webpack_public_path__ + "static/firstbatch-6be65b3d2f882ccf2caa358dc754a735.png";